// extracted by mini-css-extract-plugin
export default {"table_wrapper":"Example_table_wrapper__KFBfn","editInput":"Example_editInput__I8Gfc","fl_table":"Example_fl_table__Q5VpO"};